import React from 'react';

export function NotFound() {
  return <>Not found</>;
}
